module.exports = __webpack_public_path__ + "img/kdocs.b9bcd563.png";